module.exports = "/_next/static/images/game-3-menu-slide-3-84950c6c1ec63d3c125174b80e716f2f.png";